import React, { useEffect, useState } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import { griApiConfig } from "../config/apiConfig.js";
import { groupInfo, dataObject, griTableItems, griTableHeader, popupInfo } from "../config/GoodsIntimationForm.js";
import { PRINT_SERVER_URL, SERVER_URL } from "../config/config";
import "./Form.css";
import "./TripForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import { validate } from "../config/GoodsIntimationForm.js";
import FormColumn from "./FormColumn.js";
import { useHistory } from "react-router-dom";
import print from "print-js";


const GoodsIntimation = ({ sessionObject }) => {
  const history = useHistory();

  const [tripId, setTripId] = useState('');
  const [griId, setGriId] = useState('');
  const [biltyId, setBiltyiId] = useState('');
  const [isGRIFetched, setIsGRIFetched] = useState(false);
  const [isEditButtonClicked, setIsEditButtonClicked] = useState(false);
  const [loadingGri, setLoadingGri] = useState(false);


  let variablesFromSession = {
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    login_user_id: String(sessionObject.sessionVariables.user_id),
    role_id: String(sessionObject.sessionVariables.role_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
    fYearForFetch: sessionObject.sessionVariables.financial_year_for_fetch,
    suffix: sessionObject.sessionVariables.branch_suffix,
  };
  const branchId = JSON.parse(
    sessionStorage.getItem("branch_id")
  ).branch_id;

  const myForm = useForm(
    "Gri",
    validate,
    { ...dataObject, ...variablesFromSession },
    griApiConfig
  );
  const isAdminUser = ["1", "2"].includes(
    String(sessionObject.sessionVariables.role_id)
  );

  const getGRITimeDisplay = () => {
    const rawDate =
      myForm.pageState.created_date ||
      myForm.pageState.input_date;

    if (!rawDate) {
      return "";
    }

    const griDate = new Date(rawDate);

    if (Number.isNaN(griDate.getTime())) {
      return "";
    }

    return griDate.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const [formSections, setFormSections] = useState([
    {
      id: Date.now(),
      bilty_no: "",
      station_from_name: "",
      article_shortage: "",
      station_to_name: "",
      article_excess: "",
      gri_remarks: "",
    },
  ]);

  const handleAddSection = () => {
    const lastSection = formSections[formSections.length - 1];

    const biltyNo = lastSection?.bilty_no;
    if (!biltyNo || String(biltyNo).trim() === "") {
      return;
    }

    setFormSections([
      ...formSections,
      {
        id: Date.now(),
        bilty_no: "",
        station_from_name: "",
        article_shortage: "",
        station_to_name: "",
        article_excess: "",
        gri_remarks: "",
      },
    ]);
  };

  const handleRemoveSection = (id) => {
    if (formSections.length > 1) {
      const newFormSections = formSections.filter((section) => section.id !== id);
      setFormSections(newFormSections);
    }
  };

  const handleInputChange = (id, event) => {
    const { name, value } = event.target;
    const newFormSections = formSections.map((section) => {
      if (section.id === id) {
        return { ...section, [name]: value };
      }
      return section;
    });
    setFormSections(newFormSections);
  };



  const linkBilty = async (sectionId, bilty_no) => {
    if (!bilty_no) return;

    const trip_id = myForm.pageState.challan_ids.length > 0 ? myForm.pageState.challan_ids[0].trip_id : '';
    setTripId(trip_id);

    const url = `${SERVER_URL}/gri/check_bilty?bilty_no=${bilty_no}&trip_id=${trip_id}`;

    try {
      const response = await fetch(url, { method: "POST" });

      if (!response.ok) {
        const temp_error = await response.json();
        myForm.setPageMode("error");
        myForm.setPopupError("Please get trip data first in order to get bilty details.");
        return;
      }

      const temp_response = await response.json();

      if (!temp_response.status) {
        myForm.setPageMode("error");
        myForm.setPopupError(temp_response.message || "No Bilty found for this trip");
        return;
      }

      setFormSections(prevSections => 
        prevSections.map(section => {
          if (section.id === sectionId) {
            const { data } = temp_response;
            return {
              ...section,
              ...data
            };
          }
          return section;
        })
      );

      // if(myForm.pageState.bilty_no != "" ) {
      //   myForm.makeFocusOnParticularField("article_shortage")
      // }

    } catch (error) {
      myForm.setPageMode("error");
      myForm.setPopupError("Failed to fetch data. Please try again later.");
    }
  };

  const handleKeyPress = async (id, event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); 
      const fieldName = event.target.name;
      const section = formSections.find(sec => sec.id === id);
  
      if (event.target.name === "bilty_no") {
        if (section && section.bilty_no) {
          try {
            await linkBilty(id, section.bilty_no); 
          } catch (error) {
            console.log("Error fetching bilty details:", error);
          }
        }
        myForm.makeFocusOnParticularField("article_shortage");
      }
  
      if (!isGRIFetched) {
        if (fieldName === "gri_no") {
          if (!myForm.pageState.gri_no) {
            myForm.makeFocusOnParticularField("manual_no");
            return;
          }
          await fetchGRIData(myForm.pageState.gri_no, "gri_no");
          return;
        }

        if (fieldName === "manual_no") {
          if (!myForm.pageState.manual_no) {
            myForm.makeFocusOnParticularField("trip_no");
            return;
          }
          await fetchGRIData(myForm.pageState.manual_no, "manual_no");
          return;
        }
      }
    }
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode === "view") {
      return "disabled"; // Disable all fields in view mode
    }
  };

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    if (fieldInfoObject.name === "station_from_name") {
      return { is_branch: true };
    }
    return null;
  };

  const checkVisibilityCondition = (fieldInfo) => {
    if (fieldInfo.name === "edit_button" && myForm.pageState.role_id !== "1") {
      return false;
    } else if (
      fieldInfo.name == "delete_button" &&
      (myForm.pageState.role_id != "1" && myForm.pageState.role_id != "2")
    ) {
      return false;
    } else {
      return true;
    }
  };

  const fetchGRIData = async (value, mode = "gri_no") => {
    if (!value) return;

    setLoadingGri(true); 

    let url = "";

    if (mode === "gri_no") {
      url = `${SERVER_URL}/gri/get_gri_by_gri_no?gri_no=${value}&branch_id=${branchId}&fyear=${myForm.pageState.fYear}`;
    } else if (mode === "manual_no") {
      url = `${SERVER_URL}/gri/get_gri_by_manual_no?manual_no=${value}&branch_id=${branchId}&fyear=${myForm.pageState.fYear}`;
    }

    try {
      const response = await fetch(url, { method: "GET" });
      const data = await response.json();

      if (data.status === "error") {
        myForm.setPageMode("error");
        myForm.setPopupError(data.message || "Error fetching GRI data");
        return;
      }

      const biltyInfo = data.bilty_info || [];
      const tripIdFromResponse = data.gri.trip_id;
      const griIdFromResponse = data.gri.id;
      // const tripNoFromResponse = data.gri.trip_no; 
      const biltyIdFromResponse = biltyInfo.length > 0 ? biltyInfo[0].bilty_id : null; 
      const tripData = data.trip || {}; 
      const doorDelWeight = data.gri.door_del_weight

      setTripId(tripIdFromResponse);
      setBiltyiId(biltyIdFromResponse);
      setGriId(griIdFromResponse);

      myForm.setPageState(prevState => ({
        ...prevState,
        ...tripData,
        challan_ids: Array.isArray(tripData.booking_chalan_info)
        ? tripData.booking_chalan_info.map(challan => ({ ...challan }))
        : [],
        door_del_weight: doorDelWeight,
        total_weight: tripData.actual_weight,
        manual_no: data.gri.manual_no,
        cash_paid: data.gri.cash_paid,
        input_date: data.gri.input_date,
        created_date: data.gri.created_date,
      }));

      // if (tripIdFromResponse) {
      //   myForm.getPageOnKeyEnter(tripIdFromResponse); 
      // }

      const updatedSections = biltyInfo.map((bilty, index) => ({
        bilty_id: bilty.bilty_id,
        bilty_no: bilty.bilty_no || '',
        article_shortage: bilty.article_shortage || '',
        article_excess: bilty.article_excess || '',
        station_from_name: bilty.station_from_name || '',
        station_to_name: bilty.station_to_name || '',
        gri_remarks: bilty.gri_remarks || ' ',
        private_marka_no: bilty.private_marka_no || '',
      }));

      if (updatedSections.length === 0) {
        updatedSections.push({
          id: Date.now(),
          bilty_no: '',
          article_shortage: '',
          article_excess: '',
          station_from_name: '',
          station_to_name: '',
          gri_remarks: ' ',
        });
      }

      setFormSections(updatedSections);
      setIsGRIFetched(true);

    } catch (error) {
      console.log("Fetch error:", error);
      myForm.setPageMode("error");
      myForm.setPopupError("Failed to fetch GRI data. Please try again later.");
    } finally {
      setLoadingGri(false);
    }
  };

  console.log('ssss', myForm.pageState)

  const saveGri = async () => {
    const hasEmptyBiltyNo = formSections.some(section => !section.bilty_no);

    const tripId = myForm.pageState.challan_ids.length > 0 
      ? myForm.pageState.challan_ids[0].trip_id 
      : '';
    
    // if (hasEmptyBiltyNo) {
    //   myForm.setPageMode("error");
    //   myForm.setPopupError("Bilty number cannot be empty!");
    //   return;
    // }

    if (!tripId || isNaN(tripId)) {
      myForm.setPageMode("error");
      myForm.setPopupError("Get a trip data to save GRI.");
      return;
    }
  
    let bilty_ids = formSections.map(section => ({
      bilty_id: section.bilty_id,
      article_shortage: parseInt(section.article_shortage, 10) || 0,
      article_excess: parseInt(section.article_excess, 10) || 0,
      gri_remarks: section.gri_remarks || ""
    }));

    const allBiltyIdsEmpty = bilty_ids.every(item => !item.bilty_id);
    if (allBiltyIdsEmpty) {
      bilty_ids = [{}];
    }
  
    const payload = {
      gri_no: myForm.pageState.gri_no,
      input_date: myForm.pageState.input_date,
      manual_no: myForm.pageState.manual_no,
      trip_id: tripId,
      remarks: myForm.pageState.remarks,
      // payable_weight: myForm.pageState.payable_weight,
      // total_weight: myForm.pageState.total_weight,
      door_del_weight: myForm.pageState.door_del_weight,
      cash_paid: myForm.pageState.cash_paid,
      truck_hire: myForm.pageState.truck_hire,
      balance_bhada: myForm.pageState.balance_bhada,
      created_by: myForm.pageState.created_by,
      updated_by: myForm.pageState.created_by,
      created_from: branchId,
      fyear: myForm.pageState.fYear,
      is_deleted: 0,
      bilty_ids
    };
  
    const url = `${SERVER_URL}/gri/save-gri`;
  
    const requestOptions = { 
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };    
  
    try {
      const response = await fetch(url, requestOptions);
      const responseData = await response.json();
  
      if (responseData.status === "error") {
        myForm.setPageMode("error");
        myForm.setPopupError(responseData.message || "Error saving data");
        return;
      }

      const griNo = responseData?.gri_no || null;

      myForm.setPageMode("submitted");
      myForm.setPageState(prevState => ({
        ...prevState,
        gri_no: griNo,
        status: responseData.status,
      }));

      return { ...payload, gri_no: griNo };

    } catch (error) {
      myForm.setPageMode("error");
      myForm.setPopupError("Network error");
      return null;
    }
  };

  const updateGri = async (gri_no) => {

    const hasEmptyBiltyNo = formSections.some(section => !section.bilty_no);
    // if (hasEmptyBiltyNo) {
    //   myForm.setPageMode("error");
    //   myForm.setPopupError("Bilty number cannot be empty!");
    //   return;
    // }
  
    const tripId = myForm.pageState.challan_ids.length > 0 
      ? myForm.pageState.challan_ids[0].trip_id 
      : '';
  
      let bilty_ids = formSections.map(section => ({
        bilty_id: section.bilty_id || null,
        article_shortage: section.article_shortage,
        article_excess: section.article_excess,
        gri_remarks: section.gri_remarks,
      }));
    
      // const allBiltyIdsEmpty = bilty_ids.every(item => !item.bilty_id);
      // if (allBiltyIdsEmpty) {
      //   bilty_ids = [{}];
      // }
  
    const payload = {
      gri_no: myForm.pageState.gri_no,
      input_date: myForm.pageState.input_date,
      manual_no: myForm.pageState.manual_no,
      trip_id: tripId,
      remarks: myForm.pageState.remarks,
      // payable_weight: myForm.pageState.payable_weight,
      // total_weight: myForm.pageState.total_weight,
      door_del_weight: myForm.pageState.door_del_weight,
      cash_paid: myForm.pageState.cash_paid,
      truck_hire: myForm.pageState.truck_hire,
      balance_bhada: myForm.pageState.balance_bhada,
      created_by: myForm.pageState.created_by,
      updated_by: myForm.pageState.created_by,
      created_from: branchId,
      fyear: myForm.pageState.fYear,
      is_deleted: 0,
      bilty_ids,
    };
  
    const url = `${SERVER_URL}/gri/update-gri/${griId}`;
  
    const requestOptions = {
      method: "PUT", 
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };
  
    try {
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        const errorData = await response.json();
        myForm.setPageMode("error");
        myForm.setPopupError("Error updating data");
        return;
      }
      const responseData = await response.json();
      myForm.setPageMode("submitted");
     
      myForm.setPageState(prevState => ({
        ...prevState,
        gri_no: responseData.gri_no,
        status: responseData.status,
      }));

      return { ...payload, gri_no: responseData.gri_no };

    } catch (error) {
      myForm.setPageMode("error");
      myForm.setPopupError("Network error");
      return null;
    }
  };  
  console.log("myForm.pageState", myForm.pageState);

  const handlePrint = async (copyType) => {
    let savedPayload;
  
    if (myForm.pageMode === "edit") {
      savedPayload = await updateGri(myForm.pageState.gri_no);
    } else {
      savedPayload = await saveGri();
    }
  
    if (!savedPayload) return;
  
    const { bilty_ids, ...rest } = savedPayload;

    const modifiedBiltySectionData = formSections.map((section, index) => ({
      sr_no: index + 1,
      bilty_id: section.bilty_id,
      bilty_no: section.bilty_no,
      article_shortage: parseInt(section.article_shortage, 10) || 0,
      article_excess: parseInt(section.article_excess, 10) || 0,
      gri_remarks: section.gri_remarks || "",
      station_from_name: section.station_from_name,
      station_to_name: section.station_to_name,
      private_marka_no: section.private_marka_no || "", 
    }));


    let deliveryArticle = 0;
    let totalArticle = 0;

    const challans = myForm.pageState?.booking_chalan_info || [];

    challans.forEach((challan) => {
      if (Array.isArray(challan.bilty_info)) {
        challan.bilty_info.forEach((bilty) => {
          const packages = bilty.no_of_package || 0;
          totalArticle += packages;

          if (challan.is_crossing_challan === false) {
            deliveryArticle += packages;
          }
        });
      }
    });

    const griCreatedAt = myForm.pageState.input_date;
    const dateObj = new Date(griCreatedAt);
    const formattedDate = dateObj.toLocaleDateString('en-GB');
    const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

    const printPayload = {
      ...rest,
      data: modifiedBiltySectionData,
      client_name: 'virendra',
      file_name: 'gri',
      truck_hire: myForm.pageState?.truck_hire,
      advance_bhada: myForm.pageState?.advance_bhada,
      balance_bhada: myForm.pageState?.balance_bhada,
      payable_branch_name: myForm.pageState?.payable_branch_name,
      vehicle_no: myForm.pageState?.vehicle_no,
      booking_chalan_no: myForm.pageState.booking_chalan_info[0]?.booking_chalan_no,
      booking_chalan_date: myForm.pageState.booking_chalan_info[0]?.booking_chalan_date,
      trip_no: myForm.pageState.trip_no,
      print_copy_type: copyType,
      booking_chalan_no: myForm.pageState.challan_ids
        .map(challan => challan.booking_chalan_no)
        .filter(Boolean)
        .join(","),
      booking_chalan_date: myForm.pageState.challan_ids[0]?.booking_chalan_date,
      delivery_article: deliveryArticle,
      total_article: totalArticle,
      pm_no: myForm.pageState?.private_marka_no,
      gri_no: myForm.pageState?.gri_no,
      gri_created_date: formattedDate,
      gri_created_time: formattedTime,
      station_from_name: myForm.pageState.station_from_name,
    };
  
    try {
      const response = await fetch(`${PRINT_SERVER_URL}/bilty/print_table/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(printPayload),
      });
  
      const blob = await response.blob();
  
      print({
        printable: URL.createObjectURL(blob),
        type: "pdf",
        showModal: false,
        onPrintDialogClose: () => {
          window.location.reload();
        },
      });
    } catch (err) {
      myForm.setPageMode("error");
      myForm.setPopupError("Network error during printing");
    }
  };  

  const linkTrip = async (e, argResponse) => {
    console.log(e, argResponse);
    let temp_response;

    if (argResponse) {
      temp_response = argResponse;
    } else {
      if (myForm.pageState.trip_no === "" && e.key === "Enter") {
        myForm.makeFocusOnParticularField("bilty_no");
        return;
      }

      if (e.key === "Enter") {
        let flag = 0;
        if (myForm.pageState.bilty_type?.toLowerCase() === "c") {
          flag = 1;
        }

        let suffix = myForm.pageState.suffix || "null";

        const url =
          SERVER_URL +
          "/gri/get_trip_for_gri/?" +
          "trip_no=" +
          myForm.pageState.trip_no +
          "&station_to=" +
          myForm.pageState.created_from +
          "&fyear=" +
          myForm.pageState.fYearForFetch +
          "&companyId=" +
          myForm.pageState.company_id;

        try {
          const response = await fetch(url);
          const temp_error = await response.json();

          if (!response.ok) {
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");

            if (temp_error.detail) {
              myForm.setPopupError(String(temp_error.detail));

              if (temp_error.detail === "Trip not found") {
                myForm.makeFocusOnParticularField("trip_no");
              }
            } else {
              myForm.setPopupError("Invalid Trip");
            }

            myForm.setPageState({
              ...myForm.pageState,
              No: "",
              suffix: "",
            });

            return;
          }

          temp_response = temp_error;
        } catch (error) {
          console.error("Fetch error:", error);
          myForm.setPageMode("error");
          myForm.setPopupError("Something went wrong! Please try again.");
          return;
        }
      }
    }

    console.log("Trip Response:", temp_response);
    const totalWeight = temp_response.booking_chalan_info?.reduce(
      (sum, item) => sum + (item.total_weight || 0),
      0
    );
    
    // const doorDelWeight = temp_response.booking_chalan_info
    //   ?.filter(item => item.is_crossing_challan === false)
    //   ?.reduce((sum, item) => sum + (item.total_weight || 0), 0);
    

    const newState = {
      ...temp_response,
      challan_ids: [
        ...temp_response.booking_chalan_info,
        ...myForm.pageState["challan_ids"],
      ],
      total_weight: totalWeight,
      // door_del_weight: doorDelWeight,
    };

    myForm.setPageState({
      ...myForm.pageState,
      ...newState,
    });

    myForm.makeFocusOnParticularField("bilty_no");
  };

  const handleFocusNext = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (event.target.name === "article_excess") {
        myForm.makeFocusOnParticularField("gri_remarks"); 
      } else if (event.target.name === "gri_remarks") {
        myForm.makeFocusOnParticularField("print_button");
      } else {
        myForm.makeFocusOnParticularField("article_excess");
      }
    }
  };

  const handleDelete = async () => {
    let url = SERVER_URL + "/gri/" + griId;

    const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      console.log("Not able to delete bilty");
      return;
    }
    const temp_response = await response.json();
    if (temp_response === true) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };

  useEffect(() => {
    const truckHire = parseFloat(myForm.pageState.truck_hire) || 0;
    const totalWeight = parseFloat(myForm.pageState.total_weight) || 0;
    const totalDoorDelWeight = parseFloat(myForm.pageState.door_del_weight) || 0;
    const advanceBhada = parseFloat(myForm.pageState.advance_bhada) || 0;
    const cashPaid = parseFloat(myForm.pageState.cash_paid) || 0;
  
    const balanceBhada = truckHire - advanceBhada - cashPaid;
    const payableWeight = totalWeight - totalDoorDelWeight;
  
    myForm.setPageState(() => ({
      ...myForm.pageState,
      balance_bhada: balanceBhada.toString(),
      payable_weight: payableWeight.toString(),
    }));
  }, [myForm.pageState.truck_hire, myForm.pageState.advance_bhada, myForm.pageState.total_weight, myForm.pageState.door_del_weight, myForm.pageState.cash_paid]);

  useEffect(() => {
    if(myForm.pageState.gri_no != "" && myForm.pageMode == "edit") {
      myForm.makeFocusOnParticularField("trip_no")
    }
  }, [myForm.pageMode]);

  useEffect(() => {
    if (isGRIFetched) {
      myForm.setPageMode("view");
    }
  }, [isGRIFetched]);
  
  return (
    <div className="challan-form-container">
      <div>
         <Popup
          open={myForm.pageMode === "submitted" || myForm.pageMode === "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {myForm.pageMode === "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode === "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode === "submitted") {
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      myForm.setPageMode(myForm.previousPageMode || "write");
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.deletePopup}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">Are you sure want to delete?</div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    handleDelete();
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  Yes
                </button>
                <button
                  className="pop-up-button"
                  onClick={() => {
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Goods Receiving Intimation</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">GRI No:</label>
            <input
              className="form-input"
              type="text"
              name="gri_no"
              value={myForm.pageState.gri_no}
              onChange={(e) => {
                myForm.handleChange(e);
              }}
              onKeyPress={(e) => handleKeyPress(0, e)} 
              // ref={griNoRef}
              disabled={myForm.pageMode == "view"}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "gri_no")}
            />
            {myForm.internalValidationErrors["gri_no"] && (
              <p>{myForm.internalValidationErrors["gri_no"]}</p>
            )}

            {isGRIFetched && !isEditButtonClicked && ( 
              <button
                style={{ marginLeft: "5px", marginBottom: "5px" }}
                onClick={() => {
                  myForm.setPageMode("edit");
                  setIsEditButtonClicked(true); 
                }}
                type="button"
                className="btn btn-secondary"
              >
                Edit
              </button>
            )}
          </div>

          <div className="form-row">
            <label className="form-label">Manual No:</label>
            <input
              className="form-input"
              type="text"
              name="manual_no"
              value={myForm.pageState.manual_no}
              onChange={(e) => {
                myForm.handleChange(e);
              }}
              onKeyPress={(e) => handleKeyPress(0, e)} 
              // ref={griNoRef}
              disabled={myForm.pageMode == "view"}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "manual_no")}
            />
            {myForm.internalValidationErrors["gri_no"] && (
              <p>{myForm.internalValidationErrors["gri_no"]}</p>
            )}

            {/* {isGRIFetched && !isEditButtonClicked && ( 
              <button
                style={{ marginLeft: "5px", marginBottom: "5px" }}
                onClick={() => {
                  myForm.setPageMode("edit");
                  setIsEditButtonClicked(true); 
                }}
                type="button"
                className="btn btn-secondary"
              >
                Edit
              </button>
            )} */}
          </div>

          <div>
            <label className="form-label">GRI Date:</label>
            <input
              className="form-input-mr-statement-date"
              type="date"
              name="input_date"
              placeholder=""
              value={myForm.pageState.input_date ? myForm.pageState.input_date.split('T')[0] : ''}
              onChange={myForm.handleChange}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   console.log("Here");
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularField("consignor_name");
              //   }
              // }}
            />
            {isAdminUser && (
              <span style={{ marginLeft: "12px" }}>
                Time: <input value={getGRITimeDisplay()} disabled />
              </span>
            )}
          </div>

          <div className="form-row">
            <label className="form-last_bilty">Last GRI No:</label>
            <label className="form-last_bilty">
              {myForm.pageState.last_gri_no}
            </label>
          </div>
        </div>

        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <div className="form-row">
              <label className="form-label">Trip No:</label>
              <input
                className="form-input"
                type="text"
                name="trip_no"
                placeholder=""
                value={myForm.pageState.trip_no}
                onChange={myForm.handleChange}
                onBlur={() => {}}
                // onKeyPress={(e) => myForm.getPageOnKeyEnter(e, myForm.pageState.trip_no)}
                onKeyPress={(e) => {
                  if(e.key == "Enter") {
                      e.preventDefault();
                      linkTrip(e);
                  }
                }}
                disabled={checkDisabledCondition({ name: "trip_no" })}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "trip_no")}
              />
              {myForm.internalValidationErrors["trip_no"] && (
                <p>{myForm.internalValidationErrors["trip_no"]}</p>
              )}
            </div>
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
          </div>
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-4"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
          </div>
        </div>

        <div className="table-container">
          <DynamicViewTable
            tableHeader={griTableHeader}
            tableItems={griTableItems}
            tableValues={myForm.pageState["challan_ids"]}
            setPageStateByField={myForm.setPageStateByField}
            pageStateArray={myForm.pageState["challan_ids"]}
            fieldMapping="challan_ids"
          />
        </div>

        {formSections.map((section) => (
          <div key={section.id} className="form-input-content-block-0" style={{borderTop: "none", borderBottom: "solid black 1px"}}>
            <div className="form-row" style={{ margin: '10px' }}>
              <label className="form-label">Bilty No:</label>
              <input
                className="form-input"
                type="text"
                name="bilty_no"
                value={section.bilty_no}
                onChange={(e) => handleInputChange(section.id, e)}
                onKeyPress={(e) => handleKeyPress(section.id, e)}
                disabled={ myForm.pageMode == "view"}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_no")}
              />

              <label className="form-label" style={{marginLeft: "5px"}}>Station From:</label>
              <input
                className="form-input"
                type="text"
                name="station_from_name"
                value={section.station_from_name}
                onChange={(e) => handleInputChange(section.id, e)}
                disabled={ myForm.pageMode == "view"}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "station_from_name")}
              />

              <label className="form-label" style={{marginLeft: "5px"}}>Station To:</label>
              <input
                className="form-input"
                type="text"
                name="station_to_name"
                value={section.station_to_name}
                // onKeyPress={(e) => handleKeyPressToMove(e, articlesShortRefs)} 
                onChange={(e) => handleInputChange(section.id, e)}
                disabled={ myForm.pageMode == "view"}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "station_to_name")}
              />

              <label className="form-label" style={{marginLeft: "5px"}}>Articles Short:</label>
              <input
                className="form-input"
                type="text"
                name="article_shortage"
                value={section.article_shortage}
                onChange={(e) => handleInputChange(section.id, e)}
                disabled={ myForm.pageMode == "view"}
                onKeyPress={handleFocusNext} 
                ref={(a) => myForm.storeInputReferenceForSelect(a, "article_shortage")}
              />

              <label className="form-label" style={{marginLeft: "5px"}}>Articles Excess:</label>
              <input
                className="form-input"
                type="text"
                name="article_excess"
                value={section.article_excess}
                onChange={(e) => handleInputChange(section.id, e)}
                onKeyPress={handleFocusNext} 
                disabled={ myForm.pageMode == "view"}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "article_excess")}
              />

              <label className="form-label" style={{marginLeft: "5px"}}>Remarks:</label>
              <input
                className="form-input"
                type="text"
                name="gri_remarks"
                value={section.gri_remarks}
                onChange={(e) => handleInputChange(section.id, e)}
                onKeyPress={handleFocusNext} 
                disabled={ myForm.pageMode == "view"}
                ref={(a) => myForm.storeInputReferenceForSelect(a, "gri_remarks")}
              />
            </div>
            <div style={{marginLeft: "10px", marginTop: "7px", width: "60px"}}>
              <button 
                type="button" 
                onClick={handleAddSection}
                style={{ margin: '5px' }}
                disabled={ myForm.pageMode == "view"}
              >
                +
              </button>

              {formSections.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveSection(section.id)}
                  style={{ marginRight: '5px' }}
                  disabled={ myForm.pageMode == "view"}
                >
                  -
                </button>
              )}
            </div>
          </div>
        ))}

        {/* <div className="form-row">
          <label className="form-label">Remarks:</label>
          <input
            className="form-input"
            type="text"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)} // Update remarks independently
          />
        </div> */}

        {/* <div className="form-input-content-block-0">
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-3"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
          </div>
        </div> */}

        <div className="form-footer" style={{ marginTop: '5px', marginBottom: '5px', borderTop: '0', gap: "5px" }}>
          <button
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
            onClick={() => handlePrint("Payment Copy")}
            disabled={ myForm.pageMode == "view"}
          >
            Print Payment Copy
          </button>
          <button
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
            onClick={() => handlePrint("Office Copy")}
            disabled={ myForm.pageMode == "view"}
          >
            Print Office Copy
          </button>

          <button
            onClick={async (e) => {
              e.preventDefault(); 
              if (myForm.pageMode === "edit") {
                const gri_no = myForm.pageState.gri_no;
                await updateGri(gri_no);
              } else {
                await saveGri(); 
              }
            }}
            disabled={ myForm.pageMode == "view"}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>

          {checkVisibilityCondition({ name: "delete_button" }) && (
            <button
             onClick={() => myForm.setDeletePopup(true)}
             className="btn btn-primary"
             disabled={ myForm.pageMode == "view"}
            >
              Delete
            </button>
          )}

          <button
            onClick={() => {
              history.push("/");
            }}
            className="btn btn-primary"
          >
            Exit
          </button>
          <button
            onClick={() => {
              myForm.setPageState({
                ...dataObject,
                ...variablesFromSession,
              });
              window.location.reload();
              myForm.setPageMode("write");
            }}
            className="btn btn-primary"
          >
            New
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoodsIntimation;

